import { render, staticRenderFns } from "./TrangThaiLoiNhan.vue?vue&type=template&id=f4877454&"
import script from "./TrangThaiLoiNhan.vue?vue&type=script&lang=js&"
export * from "./TrangThaiLoiNhan.vue?vue&type=script&lang=js&"
import style0 from "./TrangThaiLoiNhan.vue?vue&type=style&index=0&id=f4877454&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports